var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    opacity: 0,
    points: "2 2 22 2 22 22 2 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0100765,20.5489909 L16.5687924,15.1177834 C19.2757462,11.7569643 18.8558509,6.86045366 15.6162194,4.00957801 C12.376588,1.15870236 7.46642848,1.36476467 4.47705019,4.47705019 C1.36476467,7.46642848 1.15870236,12.376588 4.00957801,15.6162194 C6.86045366,18.8558509 11.7569643,19.2757462 15.1177834,16.5687924 L20.5489909,22 L21.9697706,20.5792203 L22.0100765,20.5489909 Z M10.2105513,16.2261931 C7.32607634,16.2287324 4.84153339,14.1932448 4.27649185,11.3646532 C3.7114503,8.5360616 5.22329881,5.70225185 7.88737688,4.59640813 C10.5514549,3.4905644 13.625701,4.42071227 15.2298777,6.81796472 C16.8340544,9.21521717 16.5213289,12.4118351 14.4829669,14.4527375 C13.3502338,15.5868824 11.8134758,16.224782 10.2105513,16.2261931 Z",
    fill: "#7A7D84"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b4ecfa39d41bd5349c04aa7032a2cd8b.svg";
export { ForwardRef as ReactComponent };